const QUANTITY_MODE = {prorata: 'prorata', daily: 'daily'};

export default QUANTITY_MODE;